import React from "react";
import { connect } from "react-redux";
import SidebarLink from "components/Navbars/SidebarLink.js";
// JavaScript plugin that hides or shows a component based on your scroll
// reactstrap components
import { Container, ListGroup, Button, Modal } from "reactstrap";

import Backdrop from "../UI/Backdrop";
import menuIcon from "../../assets/img/icons/menuIcon.svg";
import MenuIcon from "../../assets/img/icons/iconComponent/menuIcon";
import CloseIcon from "../../assets/img/icons/iconComponent/closeIcon";
import axios from "axios";
import { apiHeaders } from "helper/apiHeader";

import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "../../helper/localStorage";
import { changeSchoolCode } from "action/auth";
import ToggleRefreshApi from "./ToggleRefreshApi";
import schoolCodeApi from "api/schoolCodeListApi";
import { Menu } from "antd";
import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";

const { SubMenu } = Menu;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showLogoutModal: false,
      sch_code: getLocalStorage("ud").master[0].sch_code,
      schoolCode: [],
    };
  }

  componentDidMount() {
    axios
      .get(
        `${this.props.globalState.host}${this.props.globalState.apiEnd.metaData}`,
        apiHeaders(this.props.globalState.apiTask.schoolcodelist)
      )
      .then((res) => {
        if (res.data.status === "201") {
          this.setState({
            schoolCode: res.data.data,
          });
        } else {
          console.log("API ERROR");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  logOut = () => {
    removeLocalStorage("ud");
    removeLocalStorage("params");
    window.location.reload();
  };

  toggleSidebar = () => {
    this.setState((state) => {
      return { open: !state.open };
    });
  };

  closeSidebar = () => {
    this.setState({ open: false });
  };

  replaceBetween = (givenString, start, end, what) => {
    return givenString.substring(0, start) + what + givenString.substring(end);
  };

  handleSchoolCodeChange = (e) => {
    this.setState({ sch_code: e.target.value });
    // this.props.changeSchoolCode(e.target.value);
    const presentString = localStorage.getItem("ud");
    const stringPositionMasterSchool = presentString.search("sch_code");
    const stringPositionSchool = presentString.search('sc":"');

    const replaceMasterSchoolCode = this.replaceBetween(
      presentString,
      stringPositionMasterSchool + 11,
      stringPositionMasterSchool + 15,
      e.target.value
    );

    const replaceSchoolCode = this.replaceBetween(
      replaceMasterSchoolCode,
      stringPositionSchool + 5,
      stringPositionSchool + 9,
      e.target.value
    );

    // localStorage.setItem("ud", replaceMasterSchoolCode);
    localStorage.setItem("ud", replaceSchoolCode);
    window.location.reload();
  };

  render() {
    const isRestricted =
      JSON.parse(localStorage.getItem("accessType")) === "93";

    const isRestrictedAdmin =
      JSON.parse(localStorage.getItem("accessType")) === "97";

    const isRestrictedRefresh =
      JSON.parse(localStorage.getItem("accessType")) === "96";

    let sidebarClasses = ["sidebar-container", "border-right"];
    let menuBtnClasses = ["menu-btn"];

    if (this.state.open) {
      sidebarClasses.push("showSidebar");
      menuBtnClasses.push("d-none");
    } else {
      sidebarClasses = sidebarClasses.filter((el) => el !== "showSidebar");
      menuBtnClasses = menuBtnClasses.filter((el) => el !== "d-none");
    }

    return (
      <>
        <Modal
          className="modal-dialog-centered"
          isOpen={this.state.showLogoutModal}
          toggle={() =>
            this.setState({
              ...this.state,
              showLogoutModal: !this.state.showLogoutModal,
            })
          }
        >
          <div className="modal-header py-2">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() =>
                this.setState({ ...this.state, showLogoutModal: false })
              }
            >
              <span aria-hidden={true}>x</span>
            </button>
          </div>
          <div className="modal-body">
            <p className="font-weight-bold">Dear {this.props.detail.name}</p>
            <p>Are you sure you want to logout?</p>
          </div>
          <div className="modal-footer">
            <Button
              onClick={() =>
                this.setState({ ...this.state, showLogoutModal: false })
              }
              color="secondary"
              type="button"
            >
              No
            </Button>
            <Button onClick={this.logOut} color="primary" type="button">
              Yes
            </Button>
          </div>
        </Modal>
        {/* <header className="sidebar-global bg-white py-4 border-right"> */}
        <div className={menuBtnClasses.join(" ")} onClick={this.toggleSidebar}>
          {/* <img src={menuIcon} alt="menu icon" /> */}
          <MenuIcon />
        </div>
        <Backdrop show={this.state.open} onClose={this.toggleSidebar} />
        <div className={sidebarClasses.join(" ")}>
          <div className="close-icon" onClick={this.toggleSidebar}>
            <CloseIcon />
          </div>
          {/* <header className="sidebar-global bg-white py-3 py-xl-4 border-right"> */}
          <header className="sidebar-global bg-white py-3 py-xl-4">
            <Container className="sticky-pos px-2">
              <div
                className="media bg-secondary p-2 rounded flex-column"
                style={{ width: "100%" }}
              >
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div>
                    <i
                      style={{ fontSize: "3rem" }}
                      className="fa fa-user-circle"
                      aria-hidden="true"
                    />
                  </div>
                  <div>
                    {/* <p className="text-muted small m-0">
                      School code:{" "} */}
                    {!isRestrictedAdmin ? (
                      <select
                        onChange={this.handleSchoolCodeChange}
                        className="sidebar-select form-control-sm  form-control-alternative"
                        value={this.state.sch_code}
                      >
                        {this.state.schoolCode.map(({ sch_code }, index) => {
                          return (
                            <option
                              key={index}
                              value={sch_code}
                              selected={this.state.sch_code === sch_code}
                            >
                              {sch_code}
                            </option>
                          );
                        })}
                      </select>
                    ) : (
                      this.props.sc
                    )}
                    {/* </p> */}
                  </div>
                </div>
                <div className="media-body ml-2">
                  <h6 className="m-0"> {this.props.detail.name} </h6>
                  <p className="text-muted small m-0 sidebar-email">
                    {" "}
                    {this.props.detail.email}{" "}
                  </p>

                  <div>{!isRestrictedRefresh && <ToggleRefreshApi />}</div>
                  <Button
                    onClick={() => this.setState({ showLogoutModal: true })}
                    color="link"
                    className=" text-left p-0"
                  >
                    {" "}
                    Logout{" "}
                  </Button>
                </div>
              </div>

              <ListGroup flush className="mt-3 ">
                <SidebarLink
                  disable={isRestricted}
                  exact={true}
                  name="Home"
                  active
                  icon="fa-home"
                  to="/"
                  fontSize="14px"
                  closeSidebar={this.closeSidebar}
                />
                <Menu
                  onClick={(e) => console.log(e)}
                  style={{ width: "100%" }}
                  mode="inline"
                >
                  <SubMenu
                    icon={<MailOutlined />}
                    key="sub1"
                    title="Assessor Role"
                  >
                    {!isRestrictedAdmin && (
                      <Menu.Item key="g1 ">
                        <SidebarLink
                          disable={isRestrictedAdmin}
                          name="Bulk Register"
                          icon="fa-bar-chart"
                          to="/register-students"
                          fontSize="12px"
                          closeSidebar={this.closeSidebar}
                        />
                      </Menu.Item>
                    )}
                    <Menu.Item key="g2">
                      <SidebarLink
                        disable={isRestricted}
                        name="Assign Test"
                        icon="fa-file-text"
                        to="/assign-test#0"
                        fontSize="12px"
                        closeSidebar={this.closeSidebar}
                      />
                    </Menu.Item>
                    <Menu.Item key="g3">
                      <SidebarLink
                        disable={isRestricted}
                        name="Feedback"
                        icon="fa-comments"
                        to="/feedback"
                        fontSize="12px"
                        closeSidebar={this.closeSidebar}
                      />
                    </Menu.Item>
                    <Menu.Item key="g4">
                      <SidebarLink
                        disable={false}
                        name="Survey"
                        icon="fa-bar-chart"
                        to="/survey"
                        fontSize="12px"
                        closeSidebar={this.closeSidebar}
                      />
                    </Menu.Item>
                  </SubMenu>
                </Menu>

                <Menu
                  onClick={(e) => console.log(e)}
                  style={{ width: "100%" }}
                  mode="inline"
                >
                  <SubMenu
                    key="sub2"
                    icon={<MailOutlined />}
                    title="Reviewer Role"
                  >
                    <Menu.Item key="g1">
                      <SidebarLink
                        disable={isRestricted}
                        name="Test List"
                        icon="fa-bar-chart"
                        to="/test-list"
                        fontSize="12px"
                        closeSidebar={this.closeSidebar}
                      />
                    </Menu.Item>
                    <Menu.Item key="g2">
                      <SidebarLink
                        disable={isRestricted}
                        name="Reported List"
                        icon="fa-bar-chart"
                        to="/reported-list"
                        fontSize="12px"
                        closeSidebar={this.closeSidebar}
                      />
                    </Menu.Item>
                    <Menu.Item key="g3">
                      <SidebarLink
                        disable={isRestricted}
                        name="Publish Ready"
                        icon="fa-bar-chart"
                        to="/publish"
                        fontSize="12px"
                        closeSidebar={this.closeSidebar}
                      />
                    </Menu.Item>
                  </SubMenu>
                </Menu>

                <Menu
                  onClick={(e) => console.log(e)}
                  style={{ width: "100%" }}
                  mode="inline"
                >
                  <SubMenu
                    icon={<MailOutlined />}
                    key="sub3"
                    title="Admin Role"
                  >
                    <Menu.Item key="g1">
                      <SidebarLink
                        disable={isRestricted}
                        name="Offline Sync Score"
                        icon="fa-bar-chart"
                        to="/sync-score"
                        fontSize="12px"
                        closeSidebar={this.closeSidebar}
                      />
                    </Menu.Item>
                    <Menu.Item key="g2">
                      <SidebarLink
                        disable={isRestricted}
                        name="Flagged Questions"
                        icon="fa-bar-chart"
                        to="/flag-questions"
                        fontSize="12px"
                        closeSidebar={this.closeSidebar}
                      />
                    </Menu.Item>
                  </SubMenu>
                </Menu>

                <SidebarLink
                  disable={isRestricted}
                  name="About"
                  icon="fa-bar-chart"
                  to="/about"
                  closeSidebar={this.closeSidebar}
                />
                <SidebarLink
                  disable={isRestricted}
                  name="Analytics"
                  icon="fa-bar-chart"
                  to="/analytics"
                  fontSize="14px"
                  closeSidebar={this.closeSidebar}
                />
                {/* <SidebarLink
                  disable={isRestricted}
                  name="Groupwise Test List"
                  icon="fa-bar-chart"
                  to="/test-list-groupwise"
                  closeSidebar={this.closeSidebar}
                /> */}
              </ListGroup>
            </Container>
          </header>
        </div>
        {/* </header> */}
      </>
    );
  }
}

const mapToProp = (state) => {
  return {
    detail: state.auth["master"] ? state.auth["master"][0] : {},
    sc: state.auth.sc,
    globalState: state.globaReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // changeSchoolCode: (sch_code) => dispatch(changeSchoolCode(sch_code)),
  };
};

export default connect(mapToProp, mapDispatchToProps)(Sidebar);
